import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export const HeroSection: React.FC = () => {
  return <section className="relative bg-gradient-to-b from-gray-100 to-white dark:from-gray-800 dark:to-gray-900 py-12 md:py-20" data-id="element-196">
      <div className="container mx-auto px-4" data-id="element-197">
        <div className="flex flex-col md:flex-row items-center" data-id="element-198">
          <div className="md:w-1/2 mb-8 md:mb-0" data-id="element-199">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900 dark:text-white" data-id="element-200">
              <span className="text-gray-900 dark:text-white" data-id="element-201">
                Kvaliteetne{' '}
              </span>
              <span className="text-green-500" data-id="element-202">Elektroonika</span> &
              <span className="text-yellow-500" data-id="element-203"> Väärismetallid</span>
            </h1>
            <p className="text-lg text-gray-700 dark:text-gray-300 mb-8 max-w-lg" data-id="element-204">
              Teie usaldusväärne turg kvaliteetsete kasutatud
              elektroonikaseadmete ja investeerimisklassi väärismetallide jaoks.
              Valuutainspireeritud disain kohtub premium ostuelamusega.
            </p>
            <div className="flex space-x-4" data-id="element-205">
              <Link to="/category/electronics" className="bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-3 rounded-md font-medium transition-colors" data-id="element-206">
                Osta Elektroonikat
              </Link>
              <Link to="/category/gold" className="bg-transparent border border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-white px-6 py-3 rounded-md font-medium transition-colors" data-id="element-207">
                Sirvi Metalle
              </Link>
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-208">
            <div className="relative" data-id="element-209">
              <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl overflow-hidden" data-id="element-210">
                <div className="p-6" data-id="element-211">
                  <div className="flex justify-between items-start mb-4" data-id="element-212">
                    <div data-id="element-213">
                      <span className="text-xs text-green-500 font-semibold uppercase tracking-wider" data-id="element-214">
                        Eriline Pakkumine
                      </span>
                      <h2 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-215">
                        MacBook Pro 2021
                      </h2>
                      <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-216">
                        Taastatud • Suurepärases Seisukorras
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center justify-center py-4" data-id="element-217">
                    <img src="https://images.unsplash.com/photo-1517336714731-489689fd1ca8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1626&q=80" alt="MacBook Pro 2021" className="w-64 h-auto object-contain" data-id="element-218" />
                  </div>
                  <div className="flex items-end justify-between mt-4" data-id="element-219">
                    <div data-id="element-220">
                      <div className="flex items-center" data-id="element-221">
                        <span className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-222">
                          1299€
                        </span>
                        <span className="ml-2 text-sm text-gray-500 dark:text-gray-400 line-through" data-id="element-223">
                          1499€
                        </span>
                      </div>
                      <span className="text-xs text-red-500" data-id="element-224">-13% SOODSAM</span>
                    </div>
                    <Link to="/product/macbook-pro-2021" className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-md text-sm font-medium flex items-center transition-colors" data-id="element-225">
                      Lisa Ostukorvi
                    </Link>
                  </div>
                </div>
              </div>
              <div className="absolute -right-4 -bottom-4 w-24 h-24 bg-yellow-500 rounded-full opacity-20 dark:opacity-10" data-id="element-226"></div>
              <div className="absolute -left-4 -top-4 w-16 h-16 bg-green-500 rounded-full opacity-20 dark:opacity-10" data-id="element-227"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};